import React from 'react';
import { Link } from 'react-router-dom';
import { FACILITIES } from '../data/facilityPages';
import './Footer.css';
import logoMain from '../commissary_connect_logo.svg';
import logoBare from '../logo_bare-1.svg';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-main">
          <div className="footer-left">
            <img src={logoMain} alt="Commissary Connect" className="footer-logo-main" />
            <p className="footer-tagline">Vancouver's Leader in Shared-Use Commercial & Commissary Kitchens</p>
          </div>
          
          <div className="footer-info">
            <div className="footer-section">
              <h4>Our Locations</h4>
              <p>Vancouver • Abbotsford • Surrey • Langley</p>
              {/* Every facility landing page, on every page of the site
                  (CMSY-76). Until 2026-09-11 the homepage tiles were the only
                  internal link to /kitchens/<slug>; when the June homepage was
                  restored those six pages became orphans — reachable from ads,
                  search and the sitemap, but from nowhere inside the site.
                  CMSY-75 gave them a link on /our-kitchens, which is where
                  people choose a kitchen; this gives them one everywhere,
                  which is what a crawler needs.
                  Names come from FACILITIES, never from the kitchens dataset:
                  the dataset still carries retired partner branding and this
                  map is where it is overridden. */}
              <div className="footer-links footer-facility-links">
                {Object.values(FACILITIES).map((f) => (
                  <Link key={f.slug} to={`/kitchens/${f.slug}`}>
                    {f.name}
                  </Link>
                ))}
              </div>
            </div>
            
            <div className="footer-section">
              <h4>Quick Links</h4>
              <div className="footer-links">
                <Link to="/our-kitchens">Our Kitchens</Link>
                <Link to="/members">Our Members</Link>
                <Link to="/referral">Member Referrals</Link>
                <Link to="/story">Our Story</Link>
                <Link to="/faq">FAQ</Link>
              </div>
            </div>
            
            <div className="footer-section">
              <h4>Get Started</h4>
              <a 
                href="/application" 
                data-apply-label="footer_apply"
                className="footer-apply-btn" 
                onClick={() => {
                  if (window.gtag) {
                    window.gtag('event', 'click', {
                      event_category: 'Application',
                      event_label: 'Footer Apply Now',
                      value: 1
                    });
                  }
                }}
              >
                Apply Now
              </a>
              <p>
                <a href="tel:7785587272" className="footer-phone" data-phone-label="footer">778.558.7272</a>
              </p>
              <p>info@commissaryconnect.com</p>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <img src={logoBare} alt="Commissary Connect" className="footer-logo-small" />
            <p>
              &copy; 2026 Commissary Connect. All rights reserved.
              <span className="footer-legal"> &middot; <Link to="/privacy">Privacy Policy</Link></span>
            </p>
          </div>
        </div>
      </div>
      {/* Release identity (git-workflow.md §Releases): SHA is the join key to
          the auto-version tag and the Vercel deployment. */}
      {/* data-build-identity is the visual suite's mask target (CMSY-110): this
          line changes on every commit, so without masking it the screenshots
          would go red on every deploy and teach everyone to ignore them. */}
      <div data-build-identity style={{ textAlign: 'center', fontSize: '0.7rem', opacity: 0.5, padding: '0.5rem 0' }}>
        v{process.env.REACT_APP_VERSION ?? 'dev'}-{(process.env.REACT_APP_GIT_SHA ?? 'local').slice(0, 8)}
      </div>
    </footer>
  );
};

export default Footer;